import {
  type Currency,
  Incoterms,
  type PricedDemandSignalDTO,
  useApiTradeV1DemandSignalsCalculateSellPriceCreate,
} from 'api';
import { logger } from 'monitor';

import { DEFAULT_TARGET_MARGIN } from '../../constants';

type OfferPricingInput = {
  siteMaterialId: number;
  demandSignalIds: number[];
  incoterm?: Incoterms;
  portOfLoadingId?: number;
  tonnesPerLoad?: string;
  tonnes?: string;
  targetMargin?: number;
  transportCostPerLoad?: number;
  transportCurrency?: Currency;
};

type HookProps = {
  onSuccess: (data: PricedDemandSignalDTO[]) => void;
};

export const useSellerOfferPrice = ({ onSuccess }: HookProps) => {
  const { data, mutate, isPending } = useApiTradeV1DemandSignalsCalculateSellPriceCreate({
    mutation: {
      onError: (error) => {
        logger.error('Error calculating price', error);
      },
      onSuccess: (data) => {
        onSuccess(data);
      },
    },
  });

  const computePrice = ({
    siteMaterialId,
    demandSignalIds,
    incoterm = Incoterms.EXW,
    portOfLoadingId,
    tonnesPerLoad,
    tonnes,
    targetMargin,
    transportCostPerLoad,
    transportCurrency,
  }: OfferPricingInput) => {
    return mutate({
      data: {
        demand_signal_ids: demandSignalIds,
        port_of_loading_id: portOfLoadingId,
        seller_incoterm: incoterm,
        site_material_ids: [siteMaterialId],
        target_margin: (targetMargin || DEFAULT_TARGET_MARGIN).toString(),
        tonnes: tonnes,
        tonnes_per_load: tonnesPerLoad,
        transport_cost_per_load: transportCostPerLoad ? transportCostPerLoad.toString() : undefined,
        transport_currency: transportCurrency,
      },
    });
  };

  return { computePrice, isPending, offerPrice: data?.[0].price_details, priceError: data?.[0].price_error };
};
